import { render, staticRenderFns } from "./packageGetStartedTasks.vue?vue&type=template&id=3076efdc"
import script from "./packageGetStartedTasks.vue?vue&type=script&lang=js"
export * from "./packageGetStartedTasks.vue?vue&type=script&lang=js"
import style0 from "./packageGetStartedTasks.vue?vue&type=style&index=0&id=3076efdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports